export default __webpack_public_path__ + "static/media/users.74f3bebf.png";